import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { AreaMenuItemModule } from '../area-menu-item/area-menu-item.module';
import { AngularUpgradeHelper } from '../helpers/AngularUpgradeHelper';
import { UserInfoModule } from '../userInfo/user-info.module';
import { ErrorComponent } from './error.component';
import { FlexModule } from '@angular/flex-layout';
import { MatIconModule } from '@angular/material/icon';

@NgModule({
    declarations: [
        ErrorComponent
    ],
    entryComponents: [
        ErrorComponent
    ],
    exports: [
        ErrorComponent
    ],
    imports: [
        CommonModule,
        AreaMenuItemModule,
        UserInfoModule,
        FlexModule,
        MatIconModule
    ],
})
export class ErrorModule {
    private commonModuleName = 'app.areas.common';

    constructor() {
        AngularUpgradeHelper.downgradeComponents(this.commonModuleName, [
            ErrorComponent
        ]);
    }
}
